// clientRequestInitator can only be executed on client side
const clientRequestInitator = ({
    endPoint, placements, context, headers, constraints, components,
}) => {
    fetch(`${endPoint}`, {
        method: 'POST',
        body: JSON.stringify({
            placements,
            context,
            headers,
            constraints,
            components,
        }),
    }).then((result) => {
        if (result.status === 204) return '';
        return result.json();
    })
        .then((response) => {
            if (response && response.modules) {
                Object.keys(response.modules).forEach((placement) => {
                    const event = new CustomEvent(`deli-received-response-${placement}`, {
                        detail: response.modules[`${placement}`],
                    });
                    document.dispatchEvent(event);
                });
            }
        }).catch((error) => {
            console.error(error);
        });
};

module.exports = {
    clientRequestInitator,
};
